import React from 'react'
import { Yup } from 'cng-web-lib'

const ValidationSchema = () => {

  return Yup.object({
    name: Yup.string().required('Required/Mandatory').max(255, 'Name cannot be more than 255 characters.'),
    inputSource: Yup.string().required('Required/Mandatory').max(255, 'Input Source cannot be more than 255 characters.'),
    outputSource: Yup.string().required('Required/Mandatory').max(255, 'Output Source cannot be more than 255 characters.')
  })
}

export default ValidationSchema

